import { SimpleLabel } from 'types/company/company';

export enum PartnerOfferType {
  Custom = 'Custom',
  Community = 'Community',
  Organization = 'Organization',
  Company = 'Company',
}

export enum PartnerOfferLayout {
  Default = 'Default',
  Simple = 'Simple',
}

export interface PartnerOffer {
  type: PartnerOfferType;
  layout?: PartnerOfferLayout;
  name: string;
  logoUrl?: string;
  bannerUrl?: string;
  bannerLabel?: SimpleLabel;
  description?: string;
  labels: SimpleLabel[];
  linkText?: string;
  linkUrl?: string;
  organizationSlug?: string;
  communitySlug?: string;
  companyId?: number;
}

export interface BackofficePartnerOffer {
  id: string;
  type: PartnerOfferType;
  layout?: PartnerOfferLayout;
  name: string;
  logoUrl?: string;
  bannerUrl?: string;
  bannerLabel?: SimpleLabel;
  description?: string;
  labels: SimpleLabel[];
  linkText?: string;
  linkUrl?: string;
  isVisible: boolean;
  isVisibleOnHome?: boolean;
  expirationDate?: string;
  audienceCountries?: string[];
  organizationId?: string;
  communityId?: number;
  companyId?: number;
  rowNumber: number;
}

export interface PartnerOffersGroupedByRowDTO {
  rowNumber: number;
  rowName: string;
  offers: PartnerOffer[];
}

export interface BackofficePartnerOffersGroupedByRowDTO {
  rowNumber: number;
  rowName: string;
  offers: BackofficePartnerOffer[];
}

export interface RowDTO {
  id: number;
  name: string;
}

export interface CreatePartnerOfferDTO {
  type: PartnerOfferType;
  layout?: PartnerOfferLayout;
  rowNumber: number;
  name?: string;
  logoUrl?: string;
  bannerUrl?: string;
  bannerLabelText?: string;
  bannerLabelColor?: string;
  description?: string;
  labels?: SimpleLabel[];
  linkText?: string;
  linkUrl?: string;
  isVisible?: boolean;
  isVisibleOnHome?: boolean;
  expirationDate?: string;
  audienceCountries?: string[];
  organizationId?: string;
  communityId?: number;
  companyId?: number;
}

export interface UpdatePartnerOfferDTO {
  type?: PartnerOfferType;
  layout?: PartnerOfferLayout;
  rowNumber?: number;
  name?: string;
  logoUrl?: string;
  bannerUrl?: string;
  bannerLabelText?: string;
  bannerLabelColor?: string;
  description?: string;
  labels?: SimpleLabel[];
  linkText?: string;
  linkUrl?: string;
  isVisible?: boolean;
  isVisibleOnHome?: boolean;
  expirationDate?: string;
  audienceCountries?: string[];
  organizationId?: string;
  communityId?: number;
  companyId?: number;
}
